module.exports = __webpack_public_path__ + "img/order-processed.4a5a5ef5.png";